module.exports = __webpack_public_path__ + "img/logo-fa-botton-blue.bf15c86.svg";